import content from "@/data/content.json";

export const API = "";

export const ytId = (url = "") => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : null;
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return err?.message || "کچھ مسئلہ پیش آیا";
}

const { verses = [], genres = [], eras = [], authors = [], works = [], articles = [], media = [], journals = [], pages = [], units = [] } = content;

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const rx = (q) => new RegExp(esc(q), "i");
const dayOfYear = () => Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 864e5);

class NotFound extends Error {}

function route(path, params = {}) {
  const [p, qs] = path.split("?");
  const q = { ...(qs ? Object.fromEntries(new URLSearchParams(qs)) : {}), ...params };
  const seg = p.split("/").filter(Boolean);
  const c = seg[0];
  const id = seg[1] ? decodeURIComponent(seg[1]) : null;

  if (p === "/home") {
    const act = verses.filter((v) => v.active);
    return { verse: act.length ? act[dayOfYear() % act.length] : null, about: content.about };
  }
  if (p === "/verses/random") {
    const act = verses.filter((v) => v.active);
    return act[Math.floor(Math.random() * act.length)];
  }
  if (c === "genres" && !id) return genres;
  if (c === "genres") {
    const g = genres.find((x) => x.slug === id);
    if (!g) throw new NotFound();
    return { ...g, works: works.filter((w) => w.genreSlug === id) };
  }
  if (c === "eras" && !id) return [...eras].sort((a, b) => (a.order || 0) - (b.order || 0));
  if (c === "eras") {
    const e = eras.find((x) => x.slug === id);
    if (!e) throw new NotFound();
    return e;
  }
  if (c === "authors" && !id)
    return authors.filter((a) => (!q.category || a.category === q.category) && (!q.q || rx(q.q).test(a.name || "")));
  if (c === "authors") {
    const a = authors.find((x) => x.slug === id);
    if (!a) throw new NotFound();
    return { ...a, works: works.filter((w) => w.authorSlug === id) };
  }
  if (c === "works" && !id)
    return works.filter(
      (w) =>
        (!q.authorSlug || w.authorSlug === q.authorSlug) &&
        (q.unitNum == null || String(w.unitNum) === String(q.unitNum)) &&
        (!q.genreSlug || w.genreSlug === q.genreSlug)
    );
  if (c === "works") {
    const w = works.find((x) => x.slug === id);
    if (!w) throw new NotFound();
    return { ...w, author: authors.find((a) => a.slug === w.authorSlug) || null };
  }
  if (c === "articles" && !id) return q.category ? articles.filter((a) => a.category === q.category) : articles;
  if (c === "articles") {
    const a = articles.find((x) => x.slug === id);
    if (!a) throw new NotFound();
    return a;
  }
  if (c === "media") return q.type ? media.filter((m) => m.type === q.type) : media;
  if (c === "journals") return journals;
  if (c === "units" && !id) return [...units].sort((a, b) => a.num - b.num);
  if (c === "units") {
    const u = units.find((x) => String(x.num) === String(id));
    if (!u) throw new NotFound();
    return { ...u, works: works.filter((w) => String(w.unitNum) === String(id)) };
  }
  if (c === "pages") {
    const pg = pages.find((x) => x.slug === id);
    if (!pg) throw new NotFound();
    return pg;
  }
  if (c === "search") {
    const term = (q.q || "").trim();
    if (term.length < 2) return { query: term, authors: [], works: [], articles: [], genres: [], eras: [], pages: [] };
    const r = rx(term);
    const match = (obj, fields) => fields.some((f) => obj[f] && r.test(obj[f]));
    return {
      query: term,
      authors: authors.filter((a) => match(a, ["name", "bio"])),
      works: works.filter((w) => match(w, ["title", "matn", "khulasa"])),
      articles: articles.filter((a) => match(a, ["title", "excerpt", "content"])),
      genres: genres.filter((g) => match(g, ["title", "desc", "content"])),
      eras: eras.filter((e) => match(e, ["title", "summary"])),
      pages: pages.filter((p2) => match(p2, ["title", "content"])),
    };
  }
  throw new NotFound();
}

export const api = {
  get: (path, opts = {}) => {
    try {
      return Promise.resolve({ data: route(path, opts.params || {}) });
    } catch (e) {
      return Promise.reject({ response: { status: 404, data: { detail: "مواد نہیں ملا" } } });
    }
  },
};
